import axios from "axios";
import Config from "../../../config";

const v2_actionDeleteLeadStatus = (statusId) => {
    return axios({
        method: "delete",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/crm/lead-status/${statusId}/deletar`
    });
};

export default v2_actionDeleteLeadStatus;
